import Icon from '../components/Icon.vue'

Icon.register({
  mercury: {
    width: 288,
    height: 512,
    paths: [
      {
        d: 'M288 208c0 68.5-47.9 125.9-112 140.4v51.6h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-64.1-14.5-112-71.9-112-140.4 0-44.2 19.9-83.7 51.2-110-2.5-1.9-4.9-3.8-7.2-5.8-24.8-21.2-39.8-48.8-43.2-78.9-0.9-7.1 4.7-13.3 11.9-13.3h40.5c5.7 0 10.6 4.1 11.7 9.8 2.5 12.5 9.6 24.3 20.7 33.8 15.4 13.2 36.1 20.4 58.4 20.4s43-7.2 58.3-20.4c11.1-9.5 18.3-21.3 20.7-33.8 1.1-5.7 6-9.8 11.8-9.8h40.5c7.2 0 12.8 6.2 11.9 13.3-3.4 30-18.5 57.6-43.2 78.8-2.3 2-4.7 4-7.2 5.8 31.3 26.4 51.2 65.9 51.2 110.1zM64 208c0 44.1 35.9 80 80 80s80-35.9 80-80-35.9-80-80-80-80 35.9-80 80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mercury.js
// module id = 1561
// module chunks = 0